module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-ico-02-blue.1fb63538.svg";